import React, { useState } from "react";
import { Table, Dropdown, Menu } from "antd";
import { CgExport } from "react-icons/cg";
import { BsThreeDots } from "react-icons/bs";
import ImageModal from "../Survelliance audit/IsoCertificationModal";
import RemainderModal from "../Survelliance audit/remainder modal/RemainderModal";
import ExportModal from "../Survelliance audit/export modal/ExportModal";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler,
  Legend
);

const AuditSurvellianceReport = () => {
  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Audit Surveillance",
        data: [48, 60, 47, 62, 69, 45, 59, 85, 49, 60, 47, 61],
        fill: true,
        backgroundColor: "rgba(0, 192, 230, 0.1)",
        borderColor: "#00c0e6",
        pointBackgroundColor: "#ffffff",
        pointBorderColor: "#00c0e6",
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        display: false, // ✅ This hides the default legend
      },
      tooltip: {
        callbacks: {
          label: (context) => `Audit Surveillance : ${context.formattedValue}`,
          title: (context) => context[0].label,
        },
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: "#00a8cc",
        borderColor: "#00a8cc",
        borderWidth: 1,
        titleFont: { weight: "bold" },
        padding: 10,
        displayColors: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        max: 90,
        ticks: {
          stepSize: 10,
          callback: (val) => val.toString().padStart(2, "0"),
        },
        grid: {
          drawTicks: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isRemainderVisible, setIsRemainderVisible] = useState(false);
  const [isExportVisible, setIsExportVisible] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState(null);

  // Dropdown menu click handler
  const handleActionClick = ({ key }) => {
    if (key === "view") {
      setIsModalVisible(true);
    } else if (key === "export") {
      setIsExportVisible(true);
    } else if (key === "reminder") {
      setIsRemainderVisible(true);
    }
  };

  const menu = (
    <Menu onClick={handleActionClick} className="expired-cert-dropdown-menu">
      {["view", "export", "reminder"].map((item) => (
        <Menu.Item
          key={item}
          className={`expired-cert-dropdown-item ${
            activeMenuItem === item ? "active" : ""
          }`}
          onClick={() => setActiveMenuItem(item)} // Optional: update active item on click
        >
          {item.charAt(0).toUpperCase() + item.slice(1)}
        </Menu.Item>
      ))}
    </Menu>
  );

  const columns = [
    {
      title: "Company Name",
      dataIndex: "companyname",
      key: "companyname",
    },
    {
      title: "Certification No",
      dataIndex: "certificationno",
      key: "certificationno",
    },
    {
      title: "Audit Due Date",
      dataIndex: "auditduedate",
      key: "auditduedate",
    },
    {
      title: "Days Remaining",
      dataIndex: "daysremaining",
      key: "daysremaining",
    },
    {
      title: "Assigned Agent",
      dataIndex: "assignedagent",
      key: "assignedagent",
    },
    {
      title: "Actions",
      key: "actions",
      render: () => (
        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <BsThreeDots style={{ fontSize: "20px", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];

  const columnData = [
    {
      key: "1",
      companyname: "Levon techno",
      certificationno: "CERT-001",
      auditduedate: "05-Mar-2024",
      daysremaining: "215 days",
      assignedagent: "Not Contacted",
    },
    {
      key: "2",
      companyname: "Amazon",
      certificationno: "CERT-002",
      auditduedate: "05-Mar-2026",
      daysremaining: "210 days",
      assignedagent: "Not Contacted",
    },
    {
      key: "3",
      companyname: "Wipro",
      certificationno: "CERT-003",
      auditduedate: "05-APR-2024",
      daysremaining: "230 days",
      assignedagent: "Not Contacted",
    },
    {
      key: "4",
      companyname: "TCS",
      certificationno: "CERT-004",
      auditduedate: "05-MAY-2025",
      daysremaining: "245 days",
      assignedagent: "In Progress",
    },
    {
      key: "5",
      companyname: "Levon techno",
      certificationno: "CERT-001",
      auditduedate: "05-Mar-2024",
      daysremaining: "215 days",
      assignedagent: "Not Contacted",
    },
  ];

  return (
     <>
      <div className="reports-page">
      <div className="reports-table mt-3">
        <div className="d-flex justify-content-end align-items-center gap-3">
          <button className="first-audit-btn">1st Audit</button>
          <button className="second-audit-btn">2nd Audit</button>
          <button className="reports-export-btn">
            <CgExport /> Export
          </button>
        </div>

        <div className="mt-4">
          <Table
            columns={columns}
            dataSource={columnData}
            pagination={{
              pageSize: Math.ceil(columnData.length / 2),
              total: columnData.length,
              className: "custom-pagination",
            }}
            scroll={{ x: "max-content" }}
          />
        </div>
      </div>
    </div>


    <div className="chart-container mt-5">
        <div className="header">
          <div>
            <h2>1st Audit Surveillance</h2>
            <span
              className="sub-label"
              style={{ fontSize: "14px", color: "grey" }}
            >
              <span style={{ color: "#3BBDC4", fontSize: "16px" }}>●</span>{" "}
              Audit Surveillance
            </span>
          </div>
          <div className="toggle-buttons">
            <button>Daily</button>
            <button>Weekly</button>
            <button className="active">Monthly</button>
          </div>
        </div>
        <div className="chart-wrapper">
          <Line data={data} options={options} />
        </div>
      </div>

      {/* Modals */}
      <ImageModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      />
      <RemainderModal
        visible={isRemainderVisible}
        onClose={() => setIsRemainderVisible(false)}
      />
      <ExportModal
        visible={isExportVisible}
        onClose={() => setIsExportVisible(false)}
      />
     </>
  );
};

export default AuditSurvellianceReport;
